import { defineEvent } from '../types/event';
export var PDP_PRESELECTED_COLOR_REJECTED = defineEvent({
    platforms: [
        {
            name: 'Heap',
            alias: 'PDP - Preselected Color Rejected'
        }
    ]
});
